<template>
  <div class="layout-center-wrap">
    <div class="page-tit__wrap">
      <h1 class="page-tit__sub">취약점 정보</h1>
      <h2 class="page-tit">공지사항</h2>
    </div>
    <article class="board-view">
      <header class="detail-view__head">
        <p class="detail-view__tit">
          {{ item.title }}
        </p>
        <div class="detail-view__info__wrap" aria-label="게시물 정보">
          <p class="detail-view__info">
            작성일 : {{ convertDateFormat(item.regDate) }}
          </p>
          <p class="detail-view__info">조회수 : {{ item.views }}</p>
        </div>
      </header>
      <div class="detail-view__body" v-dompurify-html="item.contentHtml"></div>
      <div class="detail-view__footer">
        <p class="detail-view__footer-label" aria-hidden="true">첨부파일</p>
        <a
          class="detail-view__footer-tit"
          @click.prevent="downloadFile(item.fileName, item.fileRealName)"
          >{{ item.fileRealName }}</a
        >
      </div>
      <div class="detail-view__nav">
        <a
          v-if="prevItem"
          @click.prevent="goToItem(prevItem.id)"
          class="detail-view__nav__link detail-view__nav__link--prev"
          aria-label="이전글"
        >
          <p class="detail-view__nav-label" aria-hidden="true">
            <i class="svg_icon icon_arrow_down"></i>이전글
          </p>
          <p class="detail-view__nav-tit">
            {{ prevItem.title }}
          </p>
        </a>
        <a
          v-if="nextItem"
          @click.prevent="goToItem(nextItem.id)"
          class="detail-view__nav__link"
          aria-label="다음글"
        >
          <p class="detail-view__nav-label" aria-hidden="true">
            <i class="svg_icon icon_arrow_down"></i> 다음글
          </p>
          <p class="detail-view__nav-tit">{{ nextItem.title }}</p>
        </a>
      </div>
    </article>
    <div class="btn__wrap type-bottom-board">
      <router-link to="/info/notice" class="btn btn--m btn--blue"
        >목록</router-link
      >
    </div>
  </div>
</template>

<script>
import dt from "@/component/utils/DateTime.js";
import fu from "@/component/utils/FileUtils.js";
import { inject, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  setup() {
    const axios = inject("axios");
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const showLoading = () => store.dispatch("loading/show");
    const hideLoading = () => store.dispatch("loading/hide");

    // data 정의
    const item = ref({ title: "", id: "", contentHtml: "", view_cnt: "" });
    const prevItem = ref(item.value); // 이전글 데이터
    const nextItem = ref(item.value); // 다음글 데이터
    const searchInfo = ref({ collectionType: "BOARDINFO" });
    const id = route.query.id ? route.query.id : null;
    // methods 정의
    const fetchNoticeDetail = async (id) => {
      searchInfo.value.id = id;
      showLoading();
      axios
        .post("/core/pu/view/notice/detail/get", searchInfo.value)
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            const indices =
              res.data.resList.length === 3 ? [0, 1, 2] : [1, 0, null];
            let [pre, current, next] = indices;
            item.value = res.data.resList[current];
            prevItem.value = res.data.resList[pre];
            nextItem.value = next ? res.data.resList[next] : null;
          } else {
            alert(res.data.resMsg);
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          hideLoading();
        });
    };

    const convertDateFormat = (date) => {
      return dt.dateTimeFormat(date);
    };

    const goToItem = async (id) => {
      // 1. 새로운 ID로 게시물 상세 정보 다시 불러오기
      await fetchNoticeDetail(id);

      // 2. 브라우저 히스토리를 추가하지 않고 URL만 변경
      router.replace({ query: { id } });
    };

    const downloadFile = (dir, name) => {
      fu.downloadFile("/core/pu/view/download", dir, name);
    };

    // life cycle 정의
    onMounted(() => {
      const data = sessionStorage.getItem("noticeSearchInfo");
      if (data) {
        searchInfo.value = JSON.parse(data);
      }

      if (!id) {
        router.push("/");
        return;
      }
      fetchNoticeDetail(id);
    });
    // html에서 사용될 데이터 정의
    return {
      item,
      prevItem,
      nextItem,
      convertDateFormat,
      goToItem,
      downloadFile,
    };
  },
};
</script>